import { useState } from "react";
import { TableroHome } from "../../components/Home/TableroHome";
import { AppLayout } from "../../layout/AppLayout";

const initialDashboardItems = [
    { id: 1, image: "1.svg", icon: "ti ti-user", name: "LISTA CLIENTES", url: "/clientes/lista" },
    { id: 2, image: "2.svg", icon: "ti ti-building-store", name: "LISTA EMPRESA", url: "/empresas/lista" },
    { id: 3, image: "3.svg", icon: "ti ti-book", name: "LISTA COTIZACIONES", url: "/cotizaciones/lista" },
    { id: 4, image: "1.svg", icon: "ti ti-ad-2", name: "LISTA CONTRATOS", url: "/contratos" },
    { id: 5, image: "2.svg", icon: "ti ti-calendar", name: "CALENDARIO SALONES", url: "/calendario/ver" },
    { id: 6, image: "3.svg", icon: "ti ti-basket", name: "LISTA ARTICULOS", url: "/articulos/lista" },
];

export const PageHome = () => {

    const columns = [
        { key: "id_consecutivo_coti", header: "ID Consecutivo" },
        { key: "nombre_evento_coti", header: "Nombre del Evento" },
        { key: "nombre_empresa", header: "Nombre de la Empresa" },
        { key: "name_admin", header: "Nombre del Admin" },
        { key: "fecha_evento_coti", header: "Fecha del Evento" },
        { key: "fecha_creacion_coti", header: "Fecha de Creación" },
        { key: "Estado_coti", header: "Estado de la Cotización" },
    ];

    const [dashboardItems, setDashboardItems] = useState(initialDashboardItems);
    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        {dashboardItems.map((item) => (
                            <TableroHome
                                key={item.id}
                                image={`/assets/panel/${item.image}`}
                                icons={item.icon}
                                nombre={item.name}
                                cantidad={item.quantity}
                                url={item.url}
                            />
                        ))}
                    </div>
                    {/* <div className="alert alert-success d-block text-center text-uppercase">
                        <i className="feather icon-check-circle me-2"></i>Todas tus cotizaciones relacionadas
                    </div>
                    <div className="table-responsive">
                        <table
                            className="table table-striped table dt-responsive w-100 display text-left hoverable-table"
                            style={{ fontSize: "15px", width: "100%", textAlign: "left" }}
                        >
                            <thead>
                                <tr>
                                    {columns.map((column) => (
                                        <th key={column.key}>{column.header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Evento 1</td>
                                    <td>Empresa 1</td>
                                    <td>Admin 1</td>
                                    <td>01/01/2021</td>
                                    <td>01/01/2021</td>
                                    <td>Activo</td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </div>
        </AppLayout>
    );
};
